module.exports = __webpack_public_path__ + "static/child-planting-4dc49eed962d80c4d48646e1613ee84f.jpg";